import React from 'react';
import { PaginationArrowProps } from './pagination-left-arrow';

/* DECORATION. This glyph always sits beside its own text label, so
   exposing it to the accessibility tree only adds a nameless graphic
   before every button that uses it. */
export const PaginationRightArrow: React.FC<PaginationArrowProps> = ({
  color,
}) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 6L15.5 12L9.5 18"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
